// src/TermsOfService.jsx
function TermsOfService() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', fontFamily: 'Arial' }}>
      <h1>Terms of Service</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <h2>Acceptance of Terms</h2>
      <p>By accessing or using EstatesFlow CRM, you agree to be bound by these Terms of Service.</p>
      
      <h2>Description of Service</h2>
      <p>EstatesFlow CRM provides real estate management tools including property listings, lead tracking, client management, and team collaboration.</p>
      
      <h2>User Responsibilities</h2>
      <p>You are responsible for maintaining the security of your account and for all activities that occur under your account.</p>
      
      <h2>Limitation of Liability</h2>
      <p>EstatesFlow CRM is provided "as is" without warranties of any kind.</p>
      
      <h2>Contact</h2>
      <p>Email: support@estatesflow.com</p>
    </div>
  )
}

export default TermsOfService